import { render, staticRenderFns } from "./HomePageChatMessage.vue?vue&type=template&id=de4d2140&scoped=true"
import script from "./HomePageChatMessage.vue?vue&type=script&lang=js"
export * from "./HomePageChatMessage.vue?vue&type=script&lang=js"
import style0 from "./HomePageChatMessage.vue?vue&type=style&index=0&id=de4d2140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4d2140",
  null
  
)

export default component.exports